import { useEffect, useState } from 'react';

// Hooks 
import {  useAppDispatch } from '../../misc/hooks'

// Actions
import {updateReview} from '../../slice/user'

function PopinReview() {
	const [isOpen, setIsOpen] = useState<boolean>(false)
	const dispatch = useAppDispatch()

	useEffect(() => {

		// petit délai pour ne pas sauter au visage dès le chargement
		const t = setTimeout(() => setIsOpen(true), 500)
		return () => clearTimeout(t)
	}, [])

	const close = () => setIsOpen(false)

	const handleLater = () => {
		close()
		dispatch(updateReview({review: false}))
	}

	const handleReview = async () => {
		close()
		dispatch(updateReview({review: false}))
		window.open('https://apps.shopify.com/lyntest#modal-show=WriteReviewModal', '_blank', 'noopener')
	}

	if (!isOpen) return null

	return (
		<div className="popin-review" onClick={handleLater}>
			<div
				className="popin-review__box"
				role="dialog"
				aria-modal="true"
				aria-labelledby="popin-review-title"
				onClick={(e) => e.stopPropagation()}
			>
				<button className="popin-review__close" onClick={handleLater} aria-label="Close">
					<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>
				</button>

				<div className="popin-review__stars" aria-hidden="true">
					{[0, 1, 2, 3, 4].map((i) => (
						<svg key={i} width="28" height="28" viewBox="0 0 24 24"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"></path></svg>
					))}
				</div>

				<h2 id="popin-review-title" className="popin-review__title">
					Enjoying Lyntest?
				</h2>

				<p className="popin-review__text">
					Reviews keep Lyntest growing and improving. If Lyntest helps you test your product images, a quick review on the Shopify App Store helps it keep going. It takes less than a minute
				</p>

				<div className="popin-review__actions">
					<button className="popin-review__btn primary" onClick={handleReview}>
						Leave a review
					</button>
				</div>
			</div>
		</div>
	)
}

export default PopinReview;
